const i18n = require("/src/i18n");

import {
    HMSReactiveStore,
    selectIsLocalAudioEnabled,
    selectPeers,
    selectIsConnectedToRoom,
    selectVideoTrackByID,
    selectBroadcastMessages,
    selectIsLocalScreenShared,
    selectConnectionQualityByPeerID,
    selectLocalPeer,
    selectHMSStats,
    selectRoomID,
} from "@100mslive/hms-video-store";

const hmsManager = new HMSReactiveStore();
hmsManager.triggerOnSubscribe();
const hmsStore = hmsManager.getStore();
const hmsStats = hmsManager.getStats();
const hmsActions = hmsManager.getActions();

const endCallAudio = document.getElementById("end-call-audio");

const urlParams = new URLSearchParams(window.location.search);
const userName = "backoffice"
const authToken = urlParams.get("id")
const getImagesUrl = urlParams.get("image-url");
const getPhotoGuideUrl = urlParams.get("get-photo-guide-url");
const setPhotoGuideUrl = urlParams.get("set-photo-guide-url")
const langCode = urlParams.get("lang");
i18n.setLanguage(langCode);

const deviceSelectContainer = document.getElementById("device-select-container");
const audioOutSelect = document.getElementById("audio-out-select");
const audioOutSelectLabel = document.getElementById("audio-out-select-label");
const audioInSelect = document.getElementById("audio-in-select");
const audioInSelectLabel = document.getElementById("audio-in-select-label");
const deviceSelectCancelBtn = document.getElementById("device-select-cancel-btn");
const deviceSelectNextBtn = document.getElementById("device-select-next-btn");

const videoContainer = document.getElementById("video-container");
const videoOverlay = document.getElementById("video-overlay");
const video = document.getElementById("video");
const blurredVideo = document.getElementById("blurred-video");

const muteMicBtn = document.getElementById("mute-mic-btn");

const chatBtn = document.getElementById("chat-btn");
const chatInput = document.getElementById("chat-input");
const chatInputContainer = document.getElementById("chat-input-container");
const chatSend = document.getElementById("chat-send-btn");

const hangUpBtn = document.getElementById("hang-up-btn");
const callStatusText = document.getElementById("call-status-text");

const screenShareBtn = document.getElementById("screen-share-btn");
const screenShareBtnText = document.getElementById("screen-share-btn-text");

const takePictureBtn = document.getElementById("take-picture-btn")
const takePictureBtnText = document.getElementById("take-picture-btn-text");
const takingPictureText = document.getElementById("taking-picture-text");

const systemInfo = document.getElementById("system-info");
const systemInfoTable = document.getElementById("system-info-table");

const imageContainer = document.getElementById("images");
const imageContainerParent = document.getElementById("image-div");
const imageQueue = document.getElementById("image-queue");
const imageHeading = document.getElementById("image-heading");

const photoGuideContainer = document.getElementById("photo-guide");
const photoGuideContainerParent = document.getElementById("photo-guide-div");
const photoGuideHeading = document.getElementById("photo-guide-heading");
const photoGuideLegendDone = document.querySelector("#photo-guide-legend .done");
const photoGuideLegendOptional = document.querySelector("#photo-guide-legend .optional");
const photoGuideLegendRequired = document.querySelector("#photo-guide-legend .required");

const drawCircleBtn = document.getElementById("draw-circle-btn");
const drawFrameBtn = document.getElementById("draw-frame-btn");
const drawArrowBtn = document.getElementById("draw-arrow-btn");
const drawArea = document.getElementById("video-draw-area");

const serviceBtn = document.getElementById("service-btn");
const servicePanel = document.getElementById("service-panel");
const serviceRestartCamBtn = document.getElementById("service-restart-cam-btn");
const serviceShowSystemInfo = document.getElementById("service-show-system-info-btn");

let drawingInProgress = false;
let drawingAllowed = true;
let drawingMode;
let drawingElements = [];
let drawingElement;
let drawingStartX;
let drawingStartY;
let rotation;
let finished = false;
let takingPicture = false;
let imageUploadQueue = 0;
let imageUploadQueueSize = 0;
let connected = false;
let clientConnectionQuality = -1;
let boConnectionQuality = -1;
let videoTrackStats = null;
let clientMetrics = null;
let imagesData = null;
let photoGuideData = null;
let photoGuideOptions = [];
let photoGuideSelected = [];

chatInput.setAttribute("placeholder", i18n._("Enter message") + "...")
chatSend.innerHTML = i18n._("Send")
takePictureBtnText.innerHTML = i18n._("Take picture");
screenShareBtnText.innerHTML = i18n._("Stop");
takingPictureText.innerHTML = i18n._("Taking picture") + "...";
audioOutSelectLabel.innerHTML = i18n._("Audio output device");
audioInSelectLabel.innerHTML = i18n._("Audio input device");
deviceSelectCancelBtn.innerHTML = i18n._("Cancel");
deviceSelectNextBtn.innerHTML = i18n._("Continue");
serviceRestartCamBtn.innerHTML = i18n._("Restart camera");
serviceShowSystemInfo.innerHTML = i18n._("Show info");
photoGuideHeading.innerHTML = i18n._("Picture Guide");
imageHeading.innerHTML = i18n._("Uploaded Pictures");
photoGuideLegendDone.innerHTML = i18n._("Uploaded");
photoGuideLegendOptional.innerHTML = i18n._("Optional");
photoGuideLegendRequired.innerHTML = i18n._("Required");

serviceRestartCamBtn.onclick = function () {
    hmsActions.sendBroadcastMessage("restart-camera");
}

serviceShowSystemInfo.onclick = function () {
    if (systemInfo.classList.contains("d-none")) {
        systemInfo.classList.remove("d-none");
        serviceShowSystemInfo.innerHTML = i18n._("Hide info");
    } else {
        systemInfo.classList.add("d-none");
        serviceShowSystemInfo.innerHTML = i18n._("Show info");
    }
}

serviceBtn.onclick = function () {
    if (servicePanel.classList.contains("open")) {
        servicePanel.classList.remove("open");
        return;
    }
    servicePanel.classList.add("open");
}

addEventListener("click", function (event) {
    let trustedElements = [
        serviceBtn,
        servicePanel
    ];
    serviceBtn.querySelectorAll("*").forEach(function (element) {
        trustedElements.push(element);
    })
    servicePanel.querySelectorAll("*").forEach(function (element) {
        trustedElements.push(element);
    })

    if (trustedElements.includes(event.target)) {
        return;
    }
    servicePanel.classList.remove("open");
});

async function startScreenShare() {
    try {
        await hmsActions.setScreenShareEnabled(true, {
            videoOnly: true
        });

        disallowDrawing();
        clearDrawings();

        screenShareBtn.classList.add("rtc-btn-wide");
        screenShareBtn.onclick = stopScreenShare;
        screenShareBtnText.classList.remove("d-none");
    } catch (error) {
    }
}

function stopScreenShare() {
    hmsActions.setScreenShareEnabled(false);
    allowDrawing();
    screenShareBtn.classList.remove("rtc-btn-wide");
    screenShareBtn.onclick = startScreenShare;
    screenShareBtnText.classList.add("d-none");
}

screenShareBtn.onclick = startScreenShare;

function getRealVideoSize() {
    let videoRatio = video.videoWidth / video.videoHeight;
    let realWidth = video.clientWidth
    let realHeight = video.clientHeight;
    let elementRatio = realWidth / realHeight;
    if (elementRatio > videoRatio) {
        realWidth = realHeight * videoRatio;
    } else {
        realHeight = realWidth / videoRatio;
    }
    return {realWidth, realHeight, videoRatio}
}

function fixVideoSize() {
    let realSize = getRealVideoSize();
    if (realSize["realHeight"] === 0 || realSize["realWidth"] === 0) {
        disallowDrawing();
    }

    if (rotation === 90 || rotation === 270) {
        video.style.transform = "rotate(" + rotation + "deg)";
        video.style.marginTop = "0";
        video.style.marginLeft = "0";

        blurredVideo.style.transform = "rotate(" + rotation + "deg)";
        blurredVideo.style.marginTop = "3px";
        blurredVideo.style.marginLeft = "3px";

        video.style.width = videoOverlay.clientHeight.toString() + "px"
        video.style.height = videoOverlay.clientWidth.toString() + "px"
        blurredVideo.style.width = (videoOverlay.clientHeight - 6).toString() + "px"
        blurredVideo.style.height = (videoOverlay.clientWidth - 6).toString() + "px"

        let margin = Math.abs(video.getBoundingClientRect().left + document.documentElement.scrollLeft);
        margin += Math.abs(videoOverlay.getBoundingClientRect().left + document.documentElement.scrollLeft);

        video.style.marginTop = "-" + margin + "px";
        video.style.marginLeft = margin + "px";
        blurredVideo.style.marginTop = "-" + (margin - 3) + "px";
        blurredVideo.style.marginLeft = (margin + 3) + "px";

        drawArea.style.marginLeft = (video.clientHeight - realSize["realHeight"]) / 2 + "px";
        drawArea.style.marginTop = (video.clientWidth - realSize["realWidth"]) / 2 + "px";
        drawArea.style.width = realSize["realHeight"] + "px";
        drawArea.style.height = realSize["realWidth"] + "px";

    } else {
        video.style.transform = "rotate(" + rotation + "deg)";
        blurredVideo.style.transform = "rotate(" + rotation + "deg)";

        video.style.width = videoOverlay.clientWidth.toString() + "px";
        video.style.height = videoOverlay.clientHeight.toString() + "px";
        blurredVideo.style.width = (videoOverlay.clientWidth - 6).toString() + "px";
        blurredVideo.style.height = (videoOverlay.clientHeight - 6).toString() + "px";

        video.style.marginTop = "0";
        video.style.marginLeft = "0";
        blurredVideo.style.marginTop = "3px";
        blurredVideo.style.marginLeft = "3px";

        drawArea.style.marginLeft = (video.clientWidth - realSize["realWidth"]) / 2 + "px";
        drawArea.style.marginTop = (video.clientHeight - realSize["realHeight"]) / 2 + "px";
        drawArea.style.width = realSize["realWidth"] + "px";
        drawArea.style.height = realSize["realHeight"] + "px";
    }
}

drawCircleBtn.onclick = function () {
    enableDrawing("circle");
}

drawFrameBtn.onclick = function () {
    enableDrawing("frame");
}

drawArrowBtn.onclick = function () {
    enableDrawing("arrow");
}

function removeFromArray(array, value) {
    let newArray = [];
    for (let i = 0; i < array.length; i++) {
        if (array[i] !== value) {
            newArray.push(array[i]);
        }
    }
    return newArray;
}

function allowDrawing() {
    if (drawCircleBtn) {
        if (drawCircleBtn.classList.contains("disabled")) {
            drawCircleBtn.classList.remove("disabled");
            drawCircleBtn.removeAttribute("disabled")
        }
    }
    if (drawFrameBtn) {
        if (drawFrameBtn.classList.contains("disabled")) {
            drawFrameBtn.classList.remove("disabled");
            drawFrameBtn.removeAttribute("disabled")
        }
    }
    if (drawArrowBtn) {
        if (drawArrowBtn.classList.contains("disabled")) {
            drawArrowBtn.classList.remove("disabled");
            drawArrowBtn.removeAttribute("disabled")
        }
    }
    drawingAllowed = true;
}

function disallowDrawing() {
    disableDrawing();
    if (drawCircleBtn) {
        if (!drawCircleBtn.classList.contains("disabled")) {
            drawCircleBtn.classList.add("disabled");
            drawCircleBtn.setAttribute("disabled", "")
        }
    }
    if (drawFrameBtn) {
        if (!drawFrameBtn.classList.contains("disabled")) {
            drawFrameBtn.classList.add("disabled");
            drawFrameBtn.setAttribute("disabled", "")
        }
    }
    if (drawArrowBtn) {
        if (!drawArrowBtn.classList.contains("disabled")) {
            drawArrowBtn.classList.add("disabled");
            drawArrowBtn.setAttribute("disabled", "")
        }
    }
    drawingAllowed = false;
}

function disableDrawing() {
    drawingMode = null;
    drawingInProgress = false;
    drawingStartX = null;
    drawingStartY = null;
    drawingElement = null;
    if (drawCircleBtn) {
        if (drawCircleBtn.classList.contains("active")) {
            drawCircleBtn.classList.remove("active");
        }
    }
    if (drawFrameBtn) {
        if (drawFrameBtn.classList.contains("active")) {
            drawFrameBtn.classList.remove("active");
        }
    }
    if (drawArrowBtn) {
        if (drawArrowBtn.classList.contains("active")) {
            drawArrowBtn.classList.remove("active");
        }
    }
    if (drawArea) {
        if (drawArea.classList.contains("enabled")) {
            drawArea.classList.remove("enabled");
        }
    }
}

function enableDrawing(mode) {
    if (drawingMode === mode) {
        disableDrawing();
    } else {
        if ((mode === "circle" || mode === "arrow" || mode === "frame") && drawingAllowed) {
            disableDrawing();
            drawingMode = mode;
            if (mode === "circle") {
                if (!drawCircleBtn.classList.contains("active")) {
                    drawCircleBtn.classList.add("active");
                }
            } else if (mode === "arrow") {
                if (!drawArrowBtn.classList.contains("active")) {
                    drawArrowBtn.classList.add("active");
                }
            } else if (mode === "frame") {
                if (!drawFrameBtn.classList.contains("active")) {
                    drawFrameBtn.classList.add("active");
                }
            }
            if (!drawArea.classList.contains("enabled")) {
                drawArea.classList.add("enabled");
            }
        }
    }
}

function broadcastCanvasSize() {
    if (!connected) {
        return;
    }

    let canvasSize = getRealVideoSize();
    hmsActions.sendBroadcastMessage("canvas-size:" + JSON.stringify({
        "canvas_height": canvasSize["realHeight"],
        "canvas_width": canvasSize["realWidth"],
        "canvas_ratio": canvasSize["videoRatio"]
    }));
}

function clearDrawings() {
    for (let i = 0; i < drawingElements.length; i++) {
        if (drawArea) {
            if (drawArea.contains(drawingElements[i])) {
                drawArea.removeChild(drawingElements[i]);
            }
        }
    }
}

drawArea.addEventListener("click", function (event) {
    if (drawingMode != null) {
        let clickX = Math.ceil(Math.abs(event.clientX - drawArea.getBoundingClientRect()["x"]));
        let clickY = Math.ceil(Math.abs(event.clientY - drawArea.getBoundingClientRect()["y"]));
        if (drawingInProgress) {
            let el = drawingElement;
            el.classList.add("finished");
            setTimeout(function () {
                if (drawArea.contains(el)) {
                    drawArea.removeChild(el);
                }
            }, 5000);
            drawingInProgress = false;

            if (drawingMode === "arrow") {
                let angle = Math.ceil((Math.atan2(clickY - drawingStartY, clickX - drawingStartX) * 180 / Math.PI)) - 90;
                console.log("sending arrow drawing: angle: " + angle + "deg")
                let realSize = getRealVideoSize();
                hmsActions.sendBroadcastMessage("draw:" + JSON.stringify({
                    "type": "arrow",
                    "angle": angle,
                    "canvas_height": realSize["realHeight"],
                    "canvas_width": realSize["realWidth"],
                    "canvas_ratio": realSize["videoRatio"],
                    "x": drawingStartX,
                    "y": drawingStartY
                }));

            } else if (drawingMode === "frame" || drawingMode === "circle") {
                let x = parseInt(el.style.left.replace("px", ""));
                let y = parseInt(el.style.top.replace("px", ""));
                let width = parseInt(el.style.width.replace("px", ""));
                let height = parseInt(el.style.height.replace("px", ""));
                console.log("sending " + drawingMode + " drawing: x: " + x + ", y: " + y + ", width: " + width + ", height: " + height);
                let realSize = getRealVideoSize();
                hmsActions.sendBroadcastMessage("draw:" + JSON.stringify({
                    "type": drawingMode,
                    "canvas_height": realSize["realHeight"],
                    "canvas_width": realSize["realWidth"],
                    "canvas_ratio": realSize["videoRatio"],
                    "x": x,
                    "y": y,
                    "width": width,
                    "height": height
                }));
            }
        } else {
            drawingInProgress = true;

            if (drawingMode === "circle" || drawingMode === "frame") {
                drawingElement = document.createElement("DIV");
                if (drawingMode === "frame") {
                    drawingElement.className = "bluenow-frame bluenow-drawing";
                } else {
                    drawingElement.className = "bluenow-circle bluenow-drawing";
                }
                drawingElement.style.left = clickX + "px";
                drawingElement.style.top = clickY + "px";
                drawingStartX = clickX;
                drawingStartY = clickY;
                drawingElements.push(drawingElement);
                drawArea.appendChild(drawingElement);

            } else if (drawingMode === "arrow") {
                drawingElement = document.createElement("IMG");
                drawingElement.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGEAAAD7CAYAAAB6+/qGAAABhGlDQ1BJQ0MgcHJvZmlsZQAAKJF9kT1Iw0AcxV9TpVoqDnYQcchQBcEufuFYq1CECqFWaNXB5NIvaNKQtLg4Cq4FBz8Wqw4uzro6uAqC4AeIq4uToouU+L+k0CLGg+N+vLv3uHsHCI0y06yuGKDpVTOViIuZ7KoYeEUQIfRiGmMys4w5SUrCc3zdw8fXuyjP8j735+hTcxYDfCJxjBlmlXiDeGazanDeJw6zoqwSnxOPm3RB4keuKy6/cS44LPDMsJlOzROHicVCBysdzIqmRjxFHFE1nfKFjMsq5y3OWrnGWvfkLwzl9JVlrtMcRgKLWIIEEQpqKKGMKqK06qRYSNF+3MM/5PglcinkKoGRYwEVaJAdP/gf/O7Wyk9OuEmhOND9YtsfI0BgF2jWbfv72LabJ4D/GbjS2/5KA5j9JL3e1iJHQP82cHHd1pQ94HIHGHwyZFN2JD9NIZ8H3s/om7LAwC0QXHN7a+3j9AFIU1fJG+DgEBgtUPa6x7t7Onv790yrvx/TU3LNwDp1oAAAAAZiS0dEAP8A/wD/oL2nkwAAAAlwSFlzAAAuIwAALiMBeKU/dgAAAAd0SU1FB+cKDAoFLfLMC2UAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAGgklEQVR42u3cW3MTZRzH8W9WRlrAO/tWlOlQajm14Si+EO8UR5jBchxA4ML3wbEQKIWCheg4vpN4p23KKKkX+2TMrE2bw24223x/lzCzeXY/+xz+++wWCpzKxOTuysTkAQqeqMAAY8ADYLEyMflFkRFKBQZ4BBwN/1QHZsu16ooIgwEYBxaAQ4n/Wgsov5Rr1Q0RsgPYAzwFDrZp+ypwGPitSBClgvWAyhYAzfwFHCkSRFQggCcdAADsA14C+10dpT8Jz3TRc/cCL4qyfI2GHGA3cD8ML91mb1i+TovQH8A9YK6Pw4wDlcrE5IwTc+8Ax1M65DpwvFyrLovQXSU8m/Kh60C5XKu+EWH7VdCjHueATrIWKuu3IrQvxBbCKijLrIbK+tdhqSNKQwRQAaYG1KahKuiiIQAYD48ipgZ4U+wDloDPRn6JGibhhQ4r4SwgXlYmJidHdjgKy9BHwLGcr8EaUCZ++vr3yPSElkr42BCMBnuAV8DD0K6d3xMyKMTSzFPgq3Kt+n7HIrT0gPIQP0WoAGcHCVEaIMAY8HBIhqDtsgicKdeq6zsGISxDHxPvehUlL4FT5Vq1XniEUIg9AaYp1nbqBvAGOFGuVdcKi5BDJZwFxArxg7/MIKIMAZpbkkUFaN6kU8CTcD7FQQiT8OMCDkHtIKaBx+G8hh8hLEMfhEm46ACtEIeBB1kUdFEGAPdJf0NmWDIL3E8bIkoZ4N6QF2JppAzcSxOilBLAWOgBc4xOnoXKej13hMrE5MfEj6OPMnp5AZzuFyLqE6BEvDFyiNHM0TSWr1EKAM+AjxjdzBC/27RnoMNRC8AS8Q7VqGcD+DlU1vVB9YT9xA+4BPjvZj7Y69AU9dALpkIP2Ou1/x/EDPEO3VhmCOHbsOfEW4Km/WTdVUEXdQEwQ7z9N+513jZz3RR0pS4Bxry+3Y3edLBVWuoAYDoczB7QW54DX25V0JW2ATjgHJBKlkJlXe8YIdQB+0NZ7ioonbymzVZpyUJsoAXdplulm62OPs8ZYKPgx99q6J8CniYLuijRCyZzBmgAV4APGR3/Qzh+I+fKeqG1oItaAA7mPAc0gHPA3Qzv1o1w/HM5Qxyi5d3XUkslnGch9gE4D9wCPgH+AHZl8Dv/AJ8CfwLfAFfJ9wlwBTgbhWVongAN4AfgVrlWHcjdGX7nVvjdRo4IZeDrCPgdeJsjwCXg2qAAEhDXwu/nBfEC+CkKldxp4nf085iELw8aIAFxOafJ+lUo4Naj0Jh14CTxu5cbA+wB83kBJCDmB9gjmu+4nmw+yohaGlMn/nDjXcYQH4CLefaALXrExQyXx02Ad8R/XaC+aZ0QKrk5oJoRRAO4kMcc0MUccSGjHrERruvcthVzuVZdJf6QYyUDgHPAzWEDSEDczKiOWAGOhevLdo8tWnvEcooA3wJ3hhUgAXEntDetti5v1gO2REjMEUspAHwH3B12gATE3dDuftu8lJwDOkZoWTWdIv6Gq9dJ+AJwuygACYjbof29TtaLxJ9cbfmGXtRBY5p1xGIPPWAeuFE0gATEjXAejR4AOnpFMuqwMe+BM10MTc0l39WiAiQgrobzaXQxBJ3p9DPcqIvGNIem5Q4BLhUdIAFxqUOI5U6GoJ4QWiBOhOXWRps5YH4nAWwCMd9mjmjunJ3o9i3tqIfG1NsUdM1K+MpOA0hAXNmksm4txAbzLmpY7862POJoAN8D13cqQALiejjfRsujiNleP7ON+mjMaoB4HQqbH3c6QALix3DerwPAaq/Hi/pszBrxnzG7MyoAm1TWR/r90HxXSo0ZyYS/n9f3g84Ik3tEEMGIIIIRQQQjgghGBBGMCCIYEUQwIohgRBDBiCCCEUEEI4IIRgQRjAgiGBFEMCKIYEQQwYggghFBBCOCCEYEEYwIIhgRRDAiiGBEEMGIIIIRQQQjgghGBBGMCCIYEUQwIohgRDAiiGBEEMGIIIIRQQQjgghGBBGMCCIYEUQwIohgRBDBiCCCEUEEI4IIRgQRjAgiGBFEMCKIYEQQwYggghFBBCOCCEYEEYwIIhgRRDAiiGBEEMGIIIIRQQQjgghGBBGMCCIYEUQwIhgRRDAiiGBEEMGIIIIRQQQjgghGBBGMCCIYEUQwIohgRBDBiCCCEUEEI4IIRgQRjAgiGBFEMCKIYEQQwYggghFBBCOCCEYEEYwIIhgRRDAiiGAGl11D2KZ14HxGN0gjHH+o8i86E1DU2l+p9QAAAABJRU5ErkJggg=="
                drawingElement.className = "bluenow-arrow bluenow-drawing";
                drawingElement.style.left = (clickX - 15) + "px";
                drawingElement.style.top = clickY + "px";
                drawingStartX = clickX;
                drawingStartY = clickY;
                drawingElements.push(drawingElement);
                drawArea.appendChild(drawingElement);
            }
        }
    }
}, false);

drawArea.addEventListener("mousemove", function drawAreaMouseMove(event) {
    if (drawingInProgress && drawingMode != null) {
        let posX = Math.ceil(Math.abs(event.clientX - drawArea.getBoundingClientRect()["x"]));
        let posY = Math.ceil(Math.abs(event.clientY - drawArea.getBoundingClientRect()["y"]));

        if (drawingMode === "frame") {
            let diff = Math.abs(posX - drawingStartX);
            drawingElement.style.width = diff + "px";
            if (posX < drawingStartX) {
                drawingElement.style.left = posX + "px";
            }

            diff = Math.abs(posY - drawingStartY);
            drawingElement.style.height = diff + "px";
            if (posY < drawingStartY) {
                drawingElement.style.top = posY + "px";
            }

        } else if (drawingMode === "circle") {
            let xDiff = Math.abs(posX - drawingStartX);
            let yDiff = Math.abs(posY - drawingStartY);
            let circleSize = yDiff;
            if (xDiff > yDiff) {
                circleSize = xDiff;
            }

            let inBoundsLeft = circleSize / 2 < drawingStartX;
            let inBoundsRight = circleSize / 2 < (drawArea.getBoundingClientRect()["width"] - drawingStartX);
            let inBoundsTop = circleSize / 2 < drawingStartY;
            let inBoundsBottom = circleSize / 2 < (drawArea.getBoundingClientRect()["height"] - drawingStartY)

            if (inBoundsLeft && inBoundsRight && inBoundsBottom && inBoundsTop) {
                drawingElement.style.height = circleSize + "px";
                drawingElement.style.width = circleSize + "px";
                drawingElement.style.top = (drawingStartY - (circleSize / 2)) + "px";
                drawingElement.style.left = (drawingStartX - (circleSize / 2)) + "px";
            }

        } else if (drawingMode === "arrow") {
            let angle = Math.ceil(Math.atan2(posY - drawingStartY, posX - drawingStartX) * 180 / Math.PI) - 90;
            drawingElement.style.transform = "rotate(" + angle + "deg)";
        }
    }
}, false);

drawArea.addEventListener("contextmenu", function (event) {
    event.preventDefault();
    if (drawingMode == null || !drawingInProgress) {
        return;
    }

    drawingInProgress = false;
    drawArea.removeChild(drawingElement);
    drawingElement = null;
    drawingStartX = null;
    drawingStartY = null;
    removeFromArray(drawingElements, drawingElement);
}, false);

muteMicBtn.onclick = async () => {
    const audioEnabled = !hmsStore.getState(selectIsLocalAudioEnabled);
    await hmsActions.setLocalAudioEnabled(audioEnabled);
    muteMicBtn.innerHTML = audioEnabled ? '<i class="far fa-microphone"></i>' : '<i class="far fa-microphone-slash"></i>';
};

takePictureBtn.onclick = function () {
    if (takingPicture) {
        return;
    }

    takingPicture = true;
    clearDrawings();
    disallowDrawing();

    serviceRestartCamBtn.classList.add("disabled");
    serviceRestartCamBtn.setAttribute("disabled", "");

    serviceShowSystemInfo.classList.add("disabled");
    serviceShowSystemInfo.setAttribute("disabled", "");

    takePictureBtn.classList.add("disabled");
    takePictureBtn.setAttribute("disabled", "");

    takingPictureText.classList.remove("d-none");

    video.style.opacity = 0;
    blurredVideo.style.opacity = 0;

    if (!chatInputContainer.classList.contains("d-none")) {
        toggleChatInput();
    }

    chatBtn.classList.add("disabled");
    chatBtn.setAttribute("disabled", "")

    hmsActions.sendBroadcastMessage("take-picture");
};

function toggleChatInput() {
    chatInput.value = "";

    if (chatInputContainer.classList.contains("d-none")) {
        disallowDrawing();
        chatBtn.classList.add("active");
        chatInputContainer.classList.remove("d-none");
        chatInput.focus();

    } else {
        allowDrawing();
        chatBtn.classList.remove("active");
        chatInputContainer.classList.add("d-none");
    }
}

chatBtn.onclick = toggleChatInput;

async function sendChat() {
    allowDrawing();
    chatBtn.classList.remove("active");
    await hmsActions.sendBroadcastMessage("chat-msg:" + chatInput.value.toString());
    chatInput.value = "";
    chatInputContainer.classList.add("d-none");
}

chatSend.onclick = sendChat;

chatInput.addEventListener("keyup", async function (event) {
    if (event.key === 'Enter') {
        await sendChat();
    }
});

async function hangUp() {
    await hmsActions.sendBroadcastMessage("hang-up");

    setTimeout(function () {
        finishCall();
    }, 1500)
}

hangUpBtn.onclick = hangUp;

window.onunload = hangUp;

function processPeers() {
    const peers = hmsStore.getState(selectPeers);

    peers.forEach((peer) => {
        if (peer.name !== "app-user" || !peer.videoTrack) {
            return;
        }

        hmsStore.subscribe(function (track) {
            if (!track) {
                return;
            }

            track.enabled ? hmsActions.attachVideo(track.id, video) : hmsActions.detachVideo(track.id, video);
            track.enabled ? hmsActions.attachVideo(track.id, blurredVideo) : hmsActions.detachVideo(track.id, blurredVideo);
        }, selectVideoTrackByID(peer.videoTrack));

        hmsStats.subscribe(function (stats) {
            if (!stats) return;
            videoTrackStats = stats;
            updateSystemInfo();
        }, selectHMSStats.trackStatsByID(peer.videoTrack));

        hmsStore.subscribe(function (quality) {
            if (!quality) return;

            clientConnectionQuality = quality["downlinkQuality"]

            if (clientConnectionQuality == undefined || clientConnectionQuality == null) {
                clientConnectionQuality = -1;
            }

            updateSystemInfo();
        }, selectConnectionQualityByPeerID(peer.id));
    });

    peers.forEach((peer) => {
        if (peer.isLocal) {
            hmsStore.subscribe(function (quality) {
                if (!quality) return;

                boConnectionQuality = quality["downlinkQuality"]

                if (boConnectionQuality == undefined || boConnectionQuality == null) {
                    boConnectionQuality = -1;
                }

                updateSystemInfo();
            }, selectConnectionQualityByPeerID(peer.id));

            return;
        }
    });
}

function updateImageQueue() {
    imageQueue.classList.remove("d-none");
    if (imageUploadQueue > 0) {
        imageQueue.classList.remove("done");
        imageQueue.innerHTML = '<i class="fas fa-exclamation-circle"></i>&ensp;' + i18n._("Uploading pictures") + ':&ensp;' + imageUploadQueue;

        if (imageUploadQueueSize > 0) {
            imageQueue.innerHTML += "&ensp;(" + (imageUploadQueueSize / 1024 / 1024).toFixed(1) + " MB)"
        }
    } else {
        imageQueue.classList.add("done");
        imageQueue.innerHTML = '<i class="fas fa-check-circle"></i>&ensp;' + i18n._("All pictures uploaded");
    }

    fetchImageList();
}

function pictureTakingDone() {
    takePictureBtn.classList.remove("disabled")
    takePictureBtn.removeAttribute("disabled")

    takingPictureText.classList.add("d-none");

    video.style.opacity = 1;
    blurredVideo.style.opacity = 1;

    chatBtn.classList.remove("disabled");
    chatBtn.removeAttribute("disabled");

    serviceRestartCamBtn.classList.remove("disabled");
    serviceRestartCamBtn.removeAttribute("disabled");

    serviceShowSystemInfo.classList.remove("disabled");
    serviceShowSystemInfo.removeAttribute("disabled");

    allowDrawing();

    takingPicture = false;
}

function handleMessages(messages) {
    let lastMessage = messages.pop();
    if (lastMessage === undefined) {
        return;
    }

    if (lastMessage["senderName"] === "backoffice") {
        return;
    }
    lastMessage = lastMessage["message"];

    if (lastMessage === "hang-up") {
        finishCall();

    } else if (lastMessage === "taking-picture-done") {
        pictureTakingDone();

    } else if (lastMessage.substring(0, 12) === "image-queue:") {
        imageUploadQueue = lastMessage.substring(12);
        updateImageQueue();

    } else if (lastMessage.includes("sys-info")) {
        clientMetrics = JSON.parse(lastMessage);
        updateSystemInfo();
    }
}

function setPhotoGuideImage(file_id, name) {
    if (!setPhotoGuideUrl) return;

    let roomId = hmsStore.getState(selectRoomID);
    let url = setPhotoGuideUrl + "?token=" + roomId + "&file_id=" + file_id + "&name=" + name;

    let xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4) {
            fetchImageList();
        }
    }
    xmlHttp.open("GET", url, true);
    xmlHttp.send(null);
}

function fetchPhotoGuide() {
    if (!getPhotoGuideUrl) return;

    let roomId = hmsStore.getState(selectRoomID);
    let url = getPhotoGuideUrl + "?token=" + roomId;

    let xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
            photoGuideData = JSON.parse(xmlHttp.responseText);
            buildPhotoGuide();
        }
    }
    xmlHttp.open("GET", url, true);
    xmlHttp.send(null);
}

function openImageViewer(images, index) {
    window.parent.postMessage({action: "openImageViewer", images: images, index: index}, "*");
}

function buildPhotoGuide() {
    if (photoGuideData == null) return;

    if (!photoGuideData["exist"]) return;

    photoGuideContainer.innerHTML = "";
    photoGuideContainerParent.classList.remove("d-none");

    let oldPhotoGuideOptions = [...photoGuideOptions];
    photoGuideOptions = [];

    let imageViewerEntries = []
    for (const guide of photoGuideData["guides"]) {
        imageViewerEntries.push(guide["image"]);
    }

    for (const guide of photoGuideData["guides"]) {
        photoGuideOptions.push(guide["name"])

        let imageOuter = document.createElement("DIV");
        imageOuter.className = "image-outer";
        imageOuter.addEventListener("click", function (event) {
            if (event.target.nodeName.toLowerCase() === "select") {
                return;
            }

            openImageViewer(imageViewerEntries, imageViewerEntries.indexOf(guide["image"]));
        });

        if (photoGuideSelected.includes(guide["name"])) {
            imageOuter.classList.add("photo-guide-collapsed");
        }

        let imageBlurredBg = document.createElement("IMG");
        imageBlurredBg.src = guide["thumbnail"];
        imageBlurredBg.className = "image-blurred-bg";

        let imageInner = document.createElement("IMG");
        imageInner.src = guide["thumbnail"];
        imageInner.className = "image-inner";

        let imageType = document.createElement("SPAN");
        imageType.className = "image-type";
        imageType.innerText = guide["name"];
        imageType.classList.add(guide["required"] ? "guide-required" : "guide-optional")

        imageOuter.appendChild(imageBlurredBg);
        imageOuter.appendChild(imageInner);

        let occurrences = photoGuideSelected.filter(item => item === guide["name"]).length;
        if (occurrences) {
            let imageTypeOccurrences = document.createElement("SPAN");
            imageTypeOccurrences.className = "image-type-occurrences";
            imageTypeOccurrences.innerText = occurrences.toString();
            imageOuter.appendChild(imageTypeOccurrences);
        }

        imageOuter.appendChild(imageType);


        photoGuideContainer.appendChild(imageOuter);
    }

    if (!arrayContentsMatch(oldPhotoGuideOptions, photoGuideOptions)) {
        buildImageList();
    }
}

function fetchImageList() {
    if (!getImagesUrl) return;

    let roomId = hmsStore.getState(selectRoomID);
    let url = getImagesUrl + "?token=" + roomId;

    let xmlHttp = new XMLHttpRequest();
    xmlHttp.onreadystatechange = function () {
        if (xmlHttp.readyState === 4 && xmlHttp.status === 200) {
            imagesData = JSON.parse(xmlHttp.responseText);
            buildImageList();
        }
    }
    xmlHttp.open("GET", url, true);
    xmlHttp.send(null);
}

function buildImageList() {
    if (imagesData == null) return;

    imageContainer.innerHTML = "";

    let oldPhotoGuideSelected = [...photoGuideSelected];
    photoGuideSelected = [];

    let imageViewerEntries = []
    for (const image_attrs of imagesData) {
        imageViewerEntries.push(image_attrs["image"]);
    }

    for (const image_attrs of imagesData) {
        imageContainerParent.classList.remove("d-none");

        let imageOuter = document.createElement("DIV");
        imageOuter.className = "image-outer";
        imageOuter.addEventListener("click", function (event) {
            if (event.target.nodeName.toLowerCase() == "select") {
                return;
            }

            openImageViewer(imageViewerEntries, imageViewerEntries.indexOf(image_attrs["image"]));
        });

        let imageBlurredBg = document.createElement("IMG");
        imageBlurredBg.src = image_attrs["thumbnail"];
        imageBlurredBg.className = "image-blurred-bg";

        let imageInner = document.createElement("IMG");
        imageInner.src = image_attrs["thumbnail"];
        imageInner.className = "image-inner";

        imageOuter.appendChild(imageBlurredBg);
        imageOuter.appendChild(imageInner);

        if (photoGuideOptions && photoGuideOptions.length) {
            let imageTypeSelect = document.createElement("SELECT");
            imageTypeSelect.className = "image-type-select";

            imageTypeSelect.addEventListener("click", function (event) {
                event.target.dataset.savedValue = event.target.value;
            });

            imageTypeSelect.addEventListener("change", function (event) {
                let val = event.target.value;
                let prevVal = event.target.dataset.savedValue;

                if (prevVal) {
                    const index = photoGuideSelected.indexOf(prevVal);
                    if (index !== -1) {
                        photoGuideSelected.splice(index, 1);
                    }
                }

                if (val) {
                    photoGuideSelected.push(val);
                }

                imageContainer.classList.add("reload-scheduled");
                event.target.dataset.savedValue = val;
                buildPhotoGuide();
                setPhotoGuideImage(image_attrs["file_id"], val);
            });

            let noneOptGroup = document.createElement("OPTGROUP");
            let noneOption = document.createElement("OPTION");
            noneOption.innerText = i18n._("Unassigned");
            noneOption.value = "";
            noneOptGroup.appendChild(noneOption);
            imageTypeSelect.appendChild(noneOptGroup);

            let optGroup = document.createElement("OPTGROUP");

            for (const o of photoGuideOptions) {
                let option = document.createElement("OPTION");
                option.innerText = o;
                option.value = o;

                optGroup.appendChild(option);
            }

            imageTypeSelect.appendChild(optGroup);
            imageOuter.appendChild(imageTypeSelect);

            let photoGuideName = image_attrs["photo_guide_name"];

            if (photoGuideName && photoGuideOptions.includes(photoGuideName)) {
                let imageType = document.createElement("SPAN");
                imageType.className = "image-type image-type-hover-hide";
                imageType.innerText = photoGuideName;
                imageOuter.appendChild(imageType);
                imageTypeSelect.value = photoGuideName;
                photoGuideSelected.push(photoGuideName)
            }
        }

        imageContainer.appendChild(imageOuter);
    }

    imageContainer.classList.remove("reload-scheduled");
    if (!arrayContentsMatch(oldPhotoGuideSelected, photoGuideSelected)) {
        buildPhotoGuide();
    }
}

function updateSystemInfo() {
    systemInfo.innerHTML = "";
    serviceShowSystemInfo.classList.remove("d-none");

    function addArea() {
        let area = document.createElement("TABLE");
        area.className = "area hidden";
        systemInfo.appendChild(area);
        return area;
    }

    function addAreaEntry(area, name, value) {
        let tr = document.createElement("TR");

        let td_1 = document.createElement("TD");
        td_1.className = "area-entry-name";
        td_1.innerText = name + ": ";
        tr.appendChild(td_1);

        let td_2 = document.createElement("TD");
        td_2.className = "area-entry-value";
        td_2.innerText = value;
        tr.appendChild(td_2);

        area.classList.remove("hidden");
        area.appendChild(tr);
    }

    let val;
    let batteryArea = addArea();
    let networkArea = addArea();
    let pictureTakingArea = addArea();
    let muteArea = addArea();
    let deviceStateArea = addArea();
    let deviceInfoArea = addArea();
    let videoTrackArea = addArea();

    if (videoTrackStats) {
        addAreaEntry(videoTrackArea, i18n._("Video bitrate"), formatBitrate(videoTrackStats.bitrate));
        addAreaEntry(videoTrackArea, i18n._("Video jitter"), videoTrackStats.jitter);
        addAreaEntry(videoTrackArea, i18n._("Video packets lost"), videoTrackStats.packetsLost);
        addAreaEntry(videoTrackArea, i18n._("Video resolution"), videoTrackStats.frameWidth + "x" + videoTrackStats.frameHeight);
        addAreaEntry(videoTrackArea, i18n._("Video framerate"), videoTrackStats.framesPerSecond);
    }

    switch (clientConnectionQuality.toString()) {
        case "0":
            val = i18n._("Error");
            break;
        case "1":
            val = i18n._("Very bad");
            break;
        case "2":
            val = i18n._("Bad");
            break;
        case "3":
            val = i18n._("Moderate");
            break;
        case "4":
            val = i18n._("Good");
            break;
        case "5":
            val = i18n._("Very good");
            break;
        default:
            val = i18n._("Unknown");
    }

    addAreaEntry(networkArea, i18n._("Connection quality (Client)"), val);

    switch (boConnectionQuality.toString()) {
        case "0":
            val = i18n._("Error");
            break;
        case "1":
            val = i18n._("Very Bad");
            break;
        case "2":
            val = i18n._("Bad");
            break;
        case "3":
            val = i18n._("Moderate");
            break;
        case "4":
            val = i18n._("Good");
            break;
        case "5":
            val = i18n._("Very Good");
            break;
        default:
            val = i18n._("Unknown");
    }

    addAreaEntry(networkArea, i18n._("Connection quality (BO)"), val);

    if (!clientMetrics) {
        return;
    }

    if (clientMetrics.hasOwnProperty("networkState")) {
        switch (clientMetrics["networkState"]) {
            case "mobile":
                val = i18n._("Mobile");
                break;
            case "wifi":
                val = i18n._("WiFi");
                break;
            case "ethernet":
                val = i18n._("Ethernet");
                break;
            case "bluetooth":
                val = i18n._("Bluetooth");
                break;
            case "vpn":
                val = i18n._("VPN");
                break;
            default:
                val = i18n._("Unknown");
        }

        addAreaEntry(networkArea, i18n._("Network type"), val);
    }

    if (clientMetrics.hasOwnProperty("batteryLevel")) {
        addAreaEntry(batteryArea, i18n._("Battery level"), clientMetrics["batteryLevel"] + "%");
    }

    if (clientMetrics.hasOwnProperty("batteryState")) {
        switch (clientMetrics["batteryState"]) {
            case "full":
                val = i18n._("Full");
                break;
            case "charging":
                val = i18n._("Charging");
                break;
            case "discharging":
                val = i18n._("Discharging");
                break;
            default:
                val = i18n._("Unknown");
        }

        addAreaEntry(batteryArea, i18n._("Battery state"), val);
    }

    if (clientMetrics.hasOwnProperty("batterySaveMode")) {
        addAreaEntry(batteryArea, i18n._("Energy saving mode"), clientMetrics["batterySaveMode"] ? i18n._("Yes") : i18n._("No"));
    }

    if (clientMetrics.hasOwnProperty("takingPictureStage")) {
        switch (clientMetrics["takingPictureStage"].toString()) {
            case "0":
                val = i18n._("Stream active")
                break;
            case "1":
                val = i18n._("Stopping stream")
                break;
            case "2":
                val = i18n._("Stream stopped")
                break;
            case "3":
                val = i18n._("Taking picture")
                break;
            case "4":
                val = i18n._("Starting stream")
                break;
            default:
                val = i18n._("Unknown");
        }

        addAreaEntry(pictureTakingArea, i18n._("Camera state"), val);

        if (takingPicture && clientMetrics["takingPictureStage"] === 0) {
            pictureTakingDone();
        }
    }

    if (clientMetrics.hasOwnProperty("imageUploadQueue")) {
        let imageQueueLine = clientMetrics["imageUploadQueue"];
        if (clientMetrics.hasOwnProperty("imageUploadQueueSize")) {
            imageQueueLine += " (" + (clientMetrics["imageUploadQueueSize"] / 1024 / 1024).toFixed(1) + " MB)"
        }
        addAreaEntry(pictureTakingArea, i18n._("Image queue"), imageQueueLine);

        let doUpdateImageQueue = false;

        if (clientMetrics["imageUploadQueue"] !== imageUploadQueue) {
            imageUploadQueue = clientMetrics["imageUploadQueue"]
            doUpdateImageQueue = true;
        }

        if (clientMetrics["imageUploadQueueSize"] !== imageUploadQueueSize) {
            imageUploadQueueSize = clientMetrics["imageUploadQueueSize"]
            doUpdateImageQueue = true;
        }

        if (doUpdateImageQueue) {
            updateImageQueue();
        }
    }

    if (clientMetrics.hasOwnProperty("camMuted")) {
        if (clientMetrics["camMuted"]) {
            addAreaEntry(muteArea, i18n._("Camera enabled"), i18n._("No"));
            if (takePictureBtn && !takePictureBtn.classList.contains("disabled")) {
                takePictureBtn.classList.add("disabled")
                takePictureBtn.setAttribute("disabled", "")
            }
        } else {
            addAreaEntry(muteArea, i18n._("Camera enabled"), i18n._("Yes"));
            if (takePictureBtn && takePictureBtn.classList.contains("disabled") && !takingPicture) {
                takePictureBtn.classList.remove("disabled")
                takePictureBtn.removeAttribute("disabled")
            }
        }
    }

    if (clientMetrics.hasOwnProperty("micMuted")) {
        addAreaEntry(muteArea, i18n._("Microphone enabled"), clientMetrics["micMuted"] ? i18n._("No") : i18n._("Yes"));
    }

    if (clientMetrics.hasOwnProperty("sensorOrientation")) {
        if (clientMetrics["sensorOrientation"] === "portrait_up" || clientMetrics["sensorOrientation"] === "portrait_down") {
            addAreaEntry(deviceStateArea, i18n._("Orientation"), i18n._("Vertical"));
        } else if (clientMetrics["sensorOrientation"] === "landscape_left" || clientMetrics["sensorOrientation"] === "landscape_right") {
            addAreaEntry(deviceStateArea, i18n._("Orientation"), i18n._("Horizontal"));
        }
    }

    if (clientMetrics.hasOwnProperty("volume")) {
        addAreaEntry(deviceStateArea, i18n._("Volume"), clientMetrics["volume"] + "%");
    }

    if (clientMetrics.hasOwnProperty("platformType")) {
        if (clientMetrics.hasOwnProperty("platformVersion")) {
            addAreaEntry(deviceInfoArea, i18n._("Platform"), clientMetrics["platformType"] + " " + clientMetrics["platformVersion"]);
        } else {
            addAreaEntry(deviceInfoArea, i18n._("Platform"), clientMetrics["platformType"]);
        }
    }

    if (clientMetrics.hasOwnProperty("platformMake")) {
        if (clientMetrics.hasOwnProperty("platformModel")) {
            addAreaEntry(deviceInfoArea, i18n._("Device"), clientMetrics["platformMake"] + " " + clientMetrics["platformModel"]);
        } else {
            addAreaEntry(deviceInfoArea, i18n._("Device"), clientMetrics["platformMake"]);
        }
    }

    if (clientMetrics.hasOwnProperty("appVersion")) {
        if (clientMetrics.hasOwnProperty("appBuildNumber")) {
            addAreaEntry(deviceInfoArea, i18n._("App version"), clientMetrics["appVersion"] + " (" + clientMetrics["appBuildNumber"] + ")");
        } else {
            addAreaEntry(deviceInfoArea, i18n._("App version"), clientMetrics["appVersion"]);
        }
    }

    let lastRotation = rotation;

    if (clientMetrics.hasOwnProperty("sensorOrientation") && clientMetrics.hasOwnProperty("fakeLandscape")) {
        if (clientMetrics["fakeLandscape"]) {
            if (clientMetrics["sensorOrientation"] === "landscape_right") {
                rotation = 90
            } else if (clientMetrics["sensorOrientation"] === "landscape_left") {
                rotation = 270
            } else {
                rotation = 0;
            }
        } else {
            rotation = 0;
        }

        fixVideoSize();
    } else {
        rotation = 0;
        fixVideoSize();
    }


    if (lastRotation !== rotation) {
        if (drawingElement && drawArea) {
            if (drawArea.contains(drawingElement)) {
                drawArea.removeChild(drawingElement);
            }
        }
        clearDrawings();
        drawingInProgress = false;
    }

}

function finishCall() {
    if (finished) {
        return;
    }
    finished = true;
    hmsActions.leave();
    callStatusText.innerHTML = i18n._("Call ended");
    endCallAudio.play();
    console.log("webclient:call-ended")
}

function onConnection(isConnected) {
    connected = isConnected;
    if (isConnected) {
        processPeers();
        videoContainer.classList.remove("d-none");
        callStatusText.classList.add("d-none");
        fetchImageList();
        fetchPhotoGuide();
    } else {
        videoContainer.classList.add("d-none");
        callStatusText.classList.remove("d-none");
    }
}

hmsStore.subscribe(onConnection, selectIsConnectedToRoom);
hmsStore.subscribe(processPeers, selectPeers);
hmsStore.subscribe(handleMessages, selectBroadcastMessages)

hmsStore.subscribe(function (state) {
    if (!state) {
        stopScreenShare();
    }
}, selectIsLocalScreenShared)

window.addEventListener('message', function (event) {
    if (event.data === 'triggerHangUp') {
        hangUp();
    }
});

async function startCall(audioOutputDevId, audioInputDevId) {
    callStatusText.innerHTML = i18n._("Please wait") + "...";

    await hmsActions.join({
        userName: userName,
        authToken: authToken,
        rememberDeviceSelection: false,
        settings: {
            isVideoMuted: true,
            audioMode: "voice",
            audioInputDeviceId: audioInputDevId,
            audioOutputDeviceId: audioOutputDevId
        }
    });

    setInterval(broadcastCanvasSize, 1000);
}

async function startAudioDeviceSelection() {
    deviceSelectContainer.classList.remove("d-none");
    callStatusText.classList.add("d-none");

    let lastOutputDevice = localStorage.getItem("output-device");
    let lastInputDevice = localStorage.getItem("input-device");

    (await navigator.mediaDevices?.enumerateDevices()).forEach((device) => {
        let newOption = document.createElement("option");
        newOption.innerHTML = device.label;
        newOption.value = device.deviceId;

        if (device.kind === "audiooutput") {
            newOption.selected = lastOutputDevice === device.deviceId;
            audioOutSelect.appendChild(newOption);

        } else if (device.kind === "audioinput") {
            newOption.selected = lastInputDevice === device.deviceId;
            audioInSelect.appendChild(newOption);
        }
    });

    deviceSelectNextBtn.onclick = function () {
        deviceSelectContainer.classList.add("d-none");
        callStatusText.classList.remove("d-none");

        localStorage.setItem("output-device", audioOutSelect.value);
        localStorage.setItem("input-device", audioInSelect.value);

        startCall(audioOutSelect.value, audioInSelect.value)
    }

    deviceSelectCancelBtn.onclick = function () {
        deviceSelectContainer.classList.add("d-none");
        callStatusText.classList.remove("d-none");
        callStatusText.innerHTML = i18n._("Call canceled");
        console.log("webclient:call-ended")
    }
}

async function start() {
    if (authToken == null) {
        callStatusText.innerHTML = "<strong>BlueNOW! WebClient</strong>:&ensp;No Auth Token";
        return;
    }

    const permResponse = await navigator.permissions.query({name: 'microphone'});

    if (permResponse.state === "granted") {
        await startAudioDeviceSelection();
        return;
    }

    navigator.mediaDevices.getUserMedia({video: false, audio: true})
        .then(async (stream) => {
            stream.getTracks().forEach(track => {
                track.stop();
            });
            await startAudioDeviceSelection();
        })
        .catch((_) => {
            callStatusText.innerHTML = i18n._("Permission for microphone was denied");
        });
}

start();


function formatBitrate(bps) {
    if (bps == null) return "-";

    const units = [i18n._("bps"), i18n._("kbps"), i18n._("Mbps"), i18n._("Gbps")];
    let value = bps;
    let i = 0;

    while (value >= 1000 && i < units.length - 1) {
        value /= 1000;
        i++;
    }

    const decimals = i === 0 ? 0 : 1;
    return `${value.toFixed(decimals)} ${units[i]}`;
}

function arrayContentsMatch(a, b) {
    if (a.length !== b.length) return false;
    const sortedA = [...a].sort();
    const sortedB = [...b].sort();
    return sortedA.every((val, i) => val === sortedB[i]);
}